import { render, staticRenderFns } from "./pageModel.vue?vue&type=template&id=14adbbd4&scoped=true"
import script from "./pageModel.vue?vue&type=script&lang=js"
export * from "./pageModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14adbbd4",
  null
  
)

export default component.exports